import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import { useMe } from '../../../helpers/api/users/users';
import Devices from '../../Components/Devices/Devices';
import AEListing from '../../Components/Devices/ae-listing';
import { useAdress } from '../../../helpers/api/users/users';

const extractSubdomain = (hostname: string) => {
  let effectiveHostname = hostname;
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0'
  ) {
    // TODO: ask abdou
    effectiveHostname = 'dev.deepecho.io';
  }

  const parts = effectiveHostname.split('.');
  if (parts.length > 2) {
    return parts[0];
  }
  return '';
};

const DevicesPage: React.FC = () => {
  const navigate = useNavigate();
  const user = useMe({ retry: 0 });
  const subdomain = useMemo(() => {
    if (typeof window !== 'undefined') {
      return extractSubdomain(window.location.hostname);
    }
    return '';
  }, []);
  const { data: address, isLoading, error } = useAdress(subdomain);
  useDocumentTitle('DEEPECHO - Devices Management');

  // Redirect non-admin users to home page
  // useEffect(() => {
  //   if (user.data && user.data.role !== 'admin') {
  //     navigate('/home');
  //   }
  // }, [user.data, navigate]);

  // Show loading state while user data is being fetched
  if (user.isLoading) {
    return (
      <div className="h-full bg-card-color-200 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-title-page-color-100 dark:text-white">Loading...</div>
      </div>
    );
  }

  return (
    <div className="h-full bg-card-color-200 dark:bg-gray-900">
      <div className="h-full p-4 sm:p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-title-page-color-100 dark:text-white">
            Devices Management
          </h1>
        </div>
        
        <div className="h-[calc(100%-5rem)]">
          {/* <Devices user={user.data} /> */}
          <AEListing user={user.data} address={address} />
        </div>
      </div>
    </div>
  );
};

export default DevicesPage;
